import { Button, Text } from '@react-spectrum/s2';
import ChevronRight from '@react-spectrum/s2/icons/ChevronRight';
import { useCallback, useState } from 'react';

import { TypewriterOnce } from '../components/TypewriterOnce';

type IntroScreenProps = {
	onContinue: () => void;
};

export const IntroScreen = ({ onContinue }: IntroScreenProps) => {
	const [typingDone, setTypingDone] = useState(false);
	const handleTypingDone = useCallback(() => setTypingDone(true), []);

	return (
		<div className="flex h-full w-full items-center justify-center">
			<div className="w-full max-w-[760px] px-8">
				<h2
					className="mb-8"
					style={{
						fontSize: 'clamp(26px, 4vw, 40px)',
						fontWeight: 700,
						letterSpacing: '-0.02em',
						lineHeight: 1.15,
						color: 'var(--text-primary)',
					}}
				>
					<TypewriterOnce
						text="Marketing is what I do. Part art, part science — and I bring both to your team."
						onDone={handleTypingDone}
					/>
				</h2>

				<div
					style={{
						opacity: typingDone ? 1 : 0,
						transition: 'opacity 400ms ease',
						pointerEvents: typingDone ? 'auto' : 'none',
					}}
				>
					<Button
						variant="primary"
						staticColor="black"
						fillStyle="fill"
						size="L"
						onPress={onContinue}
					>
						<Text>Tell me more</Text>
						<ChevronRight />
					</Button>
				</div>
			</div>
		</div>
	);
};
